// © 2015-2021 WDNA - All Rights Reserved

import { HighChartOptions } from 'wdna-highchart';

const line: HighChartOptions = {
  time: {
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  },
  title: {
    text: 'Waste Unloads',
    style: {
      color: '#fff',
    },
  },
  subtitle: {
    text: '',
    style: {
      color: '#fff',
    },
  },
  tooltip: {
    shared: true,
    // crosshairs: true,
  },
  legend: {
    enabled: true,
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'bottom',
  },
  lang: {
    noData: 'No data available to graph.',
  },
  noData: {
    style: {
      fontWeight: 'bold',
      fontSize: '18px',
      color: '#fff',
    },
  },
  xAxis: [
    {
      tickmarkPlacement: 'on',
      title: {
        text: 'DATES',
        style: {},
      },
      type: 'datetime',
      labels: {
        format: '{value:%Y-%m-%d}',
        rotation: 45,
        style: {
          color: 'rgba(255,255,255,1)',
        },
      },
      tickAmount: undefined,
      gridLineWidth: 0,
      crosshair: false,
    },
  ],
  yAxis: [
    {
      title: {
        text: 'DATA-1',
        style: {
          color: 'rgba(255,255,255,1)',
        },
      },
      labels: {
        style: {
          color: 'rgba(255,255,255,1)',
        },
      },
      gridLineColor: 'rgba(255,255,255,1)',
      crosshair: false,
      tickAmount: 5,
      plotLines: undefined,
    },
    {
      title: {
        text: 'DATA-2',
        style: {
          color: 'rgba(255,255,255,0.5)',
        },
      },
      labels: {
        style: {
          color: 'rgba(255,255,255,0.5)',
        },
      },
      // min: 0,
      gridLineColor: 'rgba(255,255,255,0.5)',
      crosshair: false,
      tickAmount: 5,
      plotLines: undefined,
      opposite: true,
    },
  ],
  plotOptions: {
    series: {
      cursor: 'pointer',
      marker: {
        lineWidth: 1,
      },
    },
    column: {
      stacking: 'normal',
      dataLabels: {
        enabled: false,
      },
      borderWidth: 1,
      borderRadius: 1,
      pointPadding: 0.2,
      shadow: false,
      pointWidth: 20,
    },
    line: {
      enableMouseTracking: true,
      allowPointSelect: true,
      marker: {
        enabled: true,
      },
      zIndex: -1,
    },
  },
  exporting: {
    fallbackToExportServer: false,
    buttons: {
      contextButton: {
        symbolStroke: '#fff',
        theme: {
          stroke: undefined,
          /*
          states: {
            hover: {
              fill: 'rgba(18, 47, 51, 0.2)',
              stroke: '#fff',
            },
            select: {
              fill: 'rgba(18, 47, 51, 0.2)',
              stroke: 'rgba(255, 255, 255, 0.2)',
            },
          },
          */
        },
      },
    },
  },
  chart: {
    type: 'line',
    zoomType: 'xy',
    backgroundColor: undefined,
    resetZoomButton: {
      position: {
        x: 0,
        y: -50,
      },
    },
  },
  series: [],
};

const spline: any = {
  title: line.title,
  subtitle: line.subtitle,
  tooltip: line.tooltip,
  legend: line.legend,
  land: line.lang,
  noData: line.noData,
  xAxis: line.xAxis,
  yAxis: line.yAxis,
  exporting: line.exporting,
  plotOptions: line.plotOptions,
  chart: {
    type: 'spline',
    zoomType: 'xy',
    backgroundColor: null,
    resetZoomButton: {
      position: {
        x: 0,
        y: -50,
      },
    },
  },
  series: [],
};

const column: any = {
  title: line.title,
  subtitle: line.subtitle,
  tooltip: line.tooltip,
  legend: line.legend,
  land: line.lang,
  noData: line.noData,
  xAxis: line.xAxis,
  yAxis: line.yAxis,
  exporting: line.exporting,
  plotOptions: line.plotOptions,
  chart: {
    type: 'column',
    inverted: false,
    zoomType: 'xy',
    backgroundColor: null,
    resetZoomButton: {
      position: {
        align: 'right', // by default
        verticalAlign: 'top', // by default
        x: 0,
        y: -50,
      },
    },
  },
  series: [],
};

const pressets: any = {
  line,
  spline,
  column,
};

export default pressets;
